import { Card, CardContent } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';

interface VideoCardSkeletonProps {
  densityMode?: 'comfortable' | 'compact';
}

export function VideoCardSkeleton({ densityMode = 'comfortable' }: VideoCardSkeletonProps) {
  return (
    <Card className="overflow-hidden border border-[rgb(var(--border-light))] bg-[rgb(var(--surface-primary))] shadow-sm">
      {/* Thumbnail Skeleton - 16:9 */}
      <Skeleton className="w-full aspect-video" />
      
      {/* Footer */}
      <CardContent className={`${densityMode === 'compact' ? 'p-3' : 'p-4'} space-y-2`}>
        {/* Title - 2 lines for comfortable, 1 for compact */}
        {densityMode === 'compact' ? (
          <Skeleton className="h-4 w-3/4" />
        ) : (
          <>
            <Skeleton className="h-4 w-full" />
            <Skeleton className="h-4 w-2/3" />
          </>
        )}
        
        {/* Metadata line */}
        <div className="flex items-center gap-3">
          <Skeleton className="h-3 w-16" />
          <Skeleton className="h-3 w-20" />
        </div>
      </CardContent>
    </Card>
  );
}
